import { z } from "zod";
import { schemes } from "@zeal/common";

export const createOrderPayoutRequestSchema = z.object({
  companyID: schemes.companyID(),
});

export const createOrderPayoutResponseSchema = z.object({
  success: z.boolean(),
  payout_transaction_id: schemes.uuid().optional(),
  amount: z.number(),
  order_count: z.number(),
  transaction_id: schemes.uuid().optional(),
  message: z.string().optional(),
});

export const createOrderPayoutResponseWrapperSchema = z.object({
  success: z.boolean(),
  testMode: z.boolean(),
  data: createOrderPayoutResponseSchema,
});

export type TCreateOrderPayoutRequest = z.infer<
  typeof createOrderPayoutRequestSchema
>;
export type TCreateOrderPayoutResponse = z.infer<
  typeof createOrderPayoutResponseWrapperSchema
>;
